// extracted by mini-css-extract-plugin
module.exports = {"headerHeight":"200","marginMedium":"20","siteWidth":"1200"};